import { SAVE_ORDER_DETAILS, UPDATE_FINAL_ORDER_RESPONSE, SAVE_VIRTUAL_ACCOUNT } from "../constants";

export const saveOrderDetails = (orderDetails: any) => {
  return {
    type: SAVE_ORDER_DETAILS,
    orderDetails,
  };
};

export const updateFinalOrderResponse = (finalOrderDetails: any) => {
  return {
    type: UPDATE_FINAL_ORDER_RESPONSE,
    payload: finalOrderDetails,
  };
};

export const saveVirtualAccount = (virtualAccountDetails: any) => {
  return {
    type: SAVE_VIRTUAL_ACCOUNT,
    payload: virtualAccountDetails,
  };
};
